"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _validationRules = _interopRequireDefault(require("./validationRules"));
function singleValidator(prop, dataModel) {
  var field = prop.field,
    value = prop.value;
  var tempError = {};
  (_validationRules["default"][field] || []).some(function (rule) {
    var error = rule(value, field, dataModel);
    if (error) {
      tempError[field] = {
        message: error
      };
      return true;
    }
    return false;
  });
  return tempError;
}
var _default = singleValidator;
exports["default"] = _default;
